import { getResponsiveProp, rem, responsive } from '../../styles';
export function containerBaseStyle() {
    return { width: '100%', margin: '0 auto' };
}
export function responsiveContainerWidthStyle(props) {
    const { theme } = props;
    const { container, media } = theme.sanity;
    return responsive(media, getResponsiveProp(props.$width), (val) => ({
        maxWidth: val === 'auto' ? 'none' : rem(container[val]),
    }));
}
//# sourceMappingURL=styles.js.map